/**
 * @module
 */
import {guard, INTERFACE, IS_INPUT, OBJECT, OPTIONAL, STRING} from '@acng/frontend-rubicon';
import {popup} from '@acng/frontend-discovery';
import {setPasswordInput, FormController} from 'nova';
/** @import {SubmitAction, FormArrangement} from 'nova' */
import {put} from '../../core/service/backend.js';
import {t} from '../../locale/config/translate.js';
import {PasswordRestore} from './password-restore.js';
import {user} from '../user.js';

class PasswordChange extends FormController {
  restore = new PasswordRestore();

  /**
   * @type {SubmitAction}
   */
  async submit(form, formData) {
    const url = 'user/update-password';
    const data = Object.fromEntries(formData);

    ASSERT: guard(
      data,
      OBJECT({
        old_password: STRING,
        password: STRING,
        password_confirmation: STRING,
      }),
    );

    await put(url, data, form);
    await popup(form).info(await t('userPool.changedPassword'));
    form.reset();
  }

  /**
   * @type {FormArrangement}
   */
  arrange(element) {
    ASSERT: guard(element.elements, FIELDS);
    const {nickname, old_password, password, password_confirmation} = element.elements;

    if (nickname) {
      nickname.type = 'text';
      nickname.disabled = true;
      nickname.autocomplete = 'username';
      nickname.defaultValue = user.name;
    }

    setPasswordInput(old_password, true);
    setPasswordInput(password);
    setPasswordInput(password_confirmation);
  }
}
const FIELDS = /* @__PURE__ */ INTERFACE({
  nickname: /* @__PURE__ */ OPTIONAL(IS_INPUT),
  old_password: IS_INPUT,
  password: IS_INPUT,
  password_confirmation: IS_INPUT,
});

export {PasswordChange};
